export const FLOATING_FILTERS_STORAGE_KEY = 'iptv-floating-filters';
export const FLOATING_FILTERS_EVENT = 'iptv-toggle-floating-filters';

export type FloatingFiltersDetail = { enabled: boolean };

export function readFloatingFiltersEnabled(): boolean {
  try {
    return sessionStorage.getItem(FLOATING_FILTERS_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeFloatingFiltersEnabled(enabled: boolean): void {
  try {
    sessionStorage.setItem(FLOATING_FILTERS_STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
}

export function dispatchFloatingFiltersToggle(enabled: boolean): void {
  window.dispatchEvent(
    new CustomEvent<FloatingFiltersDetail>(FLOATING_FILTERS_EVENT, { detail: { enabled } }),
  );
}
